import { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import PJPContext from "pages/PJPView/pjp.context";
import "pages/PJPView/pjp.scss";

import Calendar from "./Calendar";
import PJPDetail from "./PJPDetails";
import PJPAction from "./Action";
import PJPList from "./PJPList";

const Main = () => {
  const { SAP_ID } = useParams();

  const { officers } = useSelector((state) => state.officers);

  const { officer, setOfficer, plan, planDate } = useContext(PJPContext);

  useEffect(() => {
    if (!SAP_ID || !officers?.length) return;

    const officer = officers.filter((item) => item.SAP_ID === SAP_ID);

    setOfficer(officer[0]);
  }, [officers]);

  // useEffect(() => {}, [plan]);

  console.log("hj", officer);
  return (
    <div
      className="main-ctr"
      style={{ marginRight: "1rem", marginTop: "-3rem" }}
    >
      <div className="calendar-bar">
        <div className="info-bar">
          <div className="officer-details">
            {/* <div className="o-name"> {officer?.name ? officer?.name : ""} </div> */}
            <div className="o-name">SAP_ID : {officer?.SAP_ID} </div>
            {/* <div> Phone: {officer?.territories[0].name} </div> */}
            <div> Territory : {officer?.SAP_ID} </div>
            {/* <div> Email: {officer?.email} </div> */}
          </div>
          <div className="officer-stats">
            <div> In Review : {officer?.stats?.inReview || 0} </div>
            <div> Approved : {officer?.stats?.approved || 0}</div>
            <div> Reverted : {officer?.stats?.reverted || 0}</div>
          </div>
        </div>
        {/* <Calendar /> */}
      </div>
      {/* {plan?.beats && <PJPDetail />} */}
      <PJPList />
      {/* {plan?.beats && plan?.status === "In-Review" && <PJPAction />} */}
    </div>
  );
};

export default Main;
